import React from 'react';

interface IProps {}

export const LoaderQuizScreen: React.FC<IProps> = () => {
	return (
		<>
			{styles}
			<section className='dummy'>
				<div className='dummy__header'>
					<svg
						viewBox='0 0 768 90'
						fill='none'
						xmlns='http://www.w3.org/2000/svg'
						className='dummy__image'
					>
						<g clipPath='url(#clip0_2205_18884)'>
							<path
								fillRule='evenodd'
								clipRule='evenodd'
								d='M519.425 -479C609.56 -478.996 701.577 -450.965 756.327 -379.456C809.962 -309.402 807.96 -215.445 786.756 -129.838C766.124 -46.5397 722.809 33.2492 645.058 69.7672C568.044 105.939 480.121 86.6235 403.167 50.325C325.312 13.6012 254.977 -42.399 231.731 -125.197C207.149 -212.751 225.099 -308.891 282.497 -379.477C339.322 -449.361 429.284 -479.004 519.425 -479Z'
								fill='#555'
							/>
							<path
								fillRule='evenodd'
								clipRule='evenodd'
								d='M452.908 -534.633C502.831 -529.682 535.927 -481.096 570.995 -445.018C599.042 -416.163 611.552 -377.54 636.399 -345.856C666.411 -307.586 728.543 -287.902 732.319 -239.308C736.02 -191.681 680.427 -162.21 653.742 -122.689C629.215 -86.3629 611.789 -47.0753 581.301 -15.6448C542.846 23.9998 507.252 93.3132 452.908 84.3566C394.669 74.758 391.984 -16.2341 346.71 -54.3087C312.285 -83.2595 257.544 -75.7803 225.242 -107.108C188.971 -142.285 162.22 -189.024 155.959 -239.308C149.401 -291.981 158.971 -348.994 189.756 -392.113C219.809 -434.206 275.198 -445.288 320.562 -469.857C364.508 -493.657 403.237 -539.56 452.908 -534.633Z'
								fill='#777'
							/>
							<path
								fillRule='evenodd'
								clipRule='evenodd'
								d='M254.456 -414.632C307.814 -417.765 364.234 -400.902 402.224 -363.264C438.112 -327.708 425.991 -268.073 448.202 -222.681C476.415 -165.021 552.927 -128.027 548.673 -63.9626C544.427 -0.0126038 487.068 54.6052 428.129 79.6336C373.184 102.966 314.02 64.7545 254.456 60.9757C200.439 57.5489 141.911 87.3791 96.0718 58.5681C49.6596 29.397 36.308 -31.1685 23.1285 -84.4185C10.7843 -134.294 5.85877 -186.529 23.4635 -234.796C40.6721 -281.976 79.1592 -315.788 118.765 -346.623C159.696 -378.489 202.693 -411.594 254.456 -414.632Z'
								fill='#999'
							/>
						</g>
						<defs>
							<clipPath id='clip0_2205_18884'>
								<rect width='768' height='90' fill='white' />
							</clipPath>
						</defs>
					</svg>
				</div>
				<div className='dummy__content'>
					<div className='dummy__title' />
					<div className='dummy__list'>
						<div className='dummy__item dummy-animation' />
						<div className='dummy__item dummy-animation' />
						<div className='dummy__item dummy-animation' />
						<div className='dummy__item dummy-animation' />
					</div>
				</div>
			</section>
		</>
	);
};

const styles = (
	<style>
		{`
			.dummy {
				position: fixed;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				background-color: #fff;
				z-index: 999999;
				animation: dummy-shown 0.25s ease;
			}
			.dummy__header {
				position: relative;
				max-width: 675px;
				height: 90px;
				margin: 0 auto;
			}
			@media (max-width: 767px) {
				.dummy__header {
					height: 85px;
				}
			}
			.dummy__image {
				position: absolute;
				top: 0;
				left: 50%;
				width: 760px;
    		height: auto;
				transform: translateX(-50%);
				opacity: 0.2;
    	}
    	@media (max-width: 767px) {
				.dummy__image {
					top: -5px;
				}
			}
			@media (max-width: 540px) {
				.dummy__image {
					transform: translateX(-55%);
				}
			}
			.dummy__content {
				max-width: 568px;
				margin: 32px auto 0;
				padding: 0 20px;
			}
			@media (max-width: 767px) {
				.dummy__content {
					margin: 8px auto 0;
				}
			}
			.dummy__title {
				height: 30px;
			}
			@media (max-width: 540px) {
				.dummy__title {
					height: 60px;
				}
			}
			.dummy__list {
				margin-top: 24px;
			}
			.dummy__item {
				height: 56px;
				border-radius: 10px;
				background: linear-gradient(90deg, rgba(153,153,153, 0.1), rgba(153,153,153, 0.3), rgba(153,153,153, 0.1));
			}
			.dummy__item:not(:last-child) {
				margin-bottom: 24px;
			}
			.dummy-animation {
				background-size: 200%;
				animation: dummy-skeleton-animation 1.25s infinite reverse;
			}
			@keyframes dummy-shown {
				from {
					opacity: 0;
				}
				to {
					opacity: 1;
				}
			}
			@keyframes dummy-skeleton-animation {
					from {
						background-position: -100% 0;
					}
					to {
						background-position: 100% 0;
					}
				}
		`}
	</style>
);
